<h2 mat-dialog-title>{{ data.reference ? 'Edit reference' : 'Add reference' }}</h2>

<form [formGroup]="referenceForm" (ngSubmit)="submit()">
  <mat-dialog-content class="external-ref-dialog-content">
    <mat-form-field appearance="outline" class="external-ref-field" subscriptSizing="dynamic">
      <mat-label>Reference text</mat-label>
      <textarea
        matInput
        formControlName="referenceText"
        rows="4"
        required
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="12"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="external-ref-field" subscriptSizing="dynamic">
      <mat-label>Link URL</mat-label>
      <input matInput formControlName="referenceLink" type="url" required autocomplete="off" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-button (click)="cancel()">Cancel</button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="!referenceForm.valid"
    >
      {{ data.reference ? 'Save changes' : 'Add reference' }}
    </button>
  </mat-dialog-actions>
</form>
